export const processPayload = (data: any) => {
    let organPreferences = {};
    if (Array.isArray(data?.organList)) {
        data.organList.forEach(organ => {
            if (!organ?.LoadBindName) return;
            organPreferences[organ.LoadBindName] = organ?.Value === 'Y' || false;
        });
    }

    return {
        healthCardType: data?.healthCardType,
        healthCardNumber: data?.healthCardNumber,
        healthCardNumberRed: data?.healthCardNumberRed,
        dob: data?.dob,

        allSelected: data?.donateOrganConsent,
        preference: data?.organUseConsent,

        organ: {...organPreferences},
    };
};